import { UseCaseCard } from './UseCaseCard';
import { useCases } from '../data/useCases';
import { useI18n } from '../i18n/useI18n';

export function UseCasesSection() {
  const { t } = useI18n();

  return (
    <section className="section" id="use-cases">
      <div className="section-heading">
        <p className="eyebrow">{t('useCases.eyebrow')}</p>
        <h2>{t('useCases.title')}</h2>
        <p>{t('useCases.text')}</p>
      </div>
      <div className="card-grid">
        {useCases.map((item) => (
          <UseCaseCard item={item} key={item.id} />
        ))}
      </div>
    </section>
  );
}
